import React from 'react';
import cx from 'classnames';
import './style.scss';
// import expandImg from 'public/img/expand.png';
// import recoverImg from 'public/img/recover.png';

class Card extends React.Component {
  render() {
    const { children, className, header, headerStyle, ...rest } = this.props;
    const cardClassName = cx(className, 'qf-card');
    const headerCmp = header ? (
      <div className="qf-card__header" style={headerStyle}>
        <div style={{ marginLeft: 38 }}>{header}</div>
      </div>
    ) : null;
    
    return (
      <div className={cardClassName} {...rest}>
        {headerCmp}
        {children}
      </div>
    );
  }
}
// const Card = ({ children, className, header, headerStyle, ...rest }) => {
//   const cardClassName = cx(className, 'qf-card');
//   const headerCmp = header ? (
//     <div className="qf-card__header" style={headerStyle}>
//       <div style={{ marginLeft: 38 }}>{header}</div>
//     </div>
//   ) : null;
  
//   return (
//     <div className={cardClassName} {...rest}>
//       {headerCmp}
//       {children}
//     </div>
//   );
// };
// const imgStyle = {
//   width: 16,
//   height: 16,
// };
// class Card extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       height: props.height || 'auto',
//       expanded: false,
//     };
//   }

//   renderExpand = () => {
//     const { enableExpand } = this.props;
//     if (!enableExpand) {
//       return null;
//     }
//     return (
//       <i onClick={this.expand} className="qf-card__expand-icon">
//         {this.state.expanded ? <img src={recoverImg} alt="" style={imgStyle} /> : <img src={expandImg} alt="" style={imgStyle} />}
//       </i>
//     );
//   }

//   expand = () => {
//     this.setState(prevState => ({
//       expanded: !prevState.expanded,
//       height: prevState.expanded ? this.props.height : 'auto',
//     }));
//   }

//   render() {
//     const { style, className, children } = this.props;
//     const cardClassName = cx('qf-card', className);  
//     const cardStyle = {
//       ...style,
//       height: this.state.height,
//     };
//     return (
//       <div className={cardClassName} style={cardStyle}>
//         {children}
//         {this.renderExpand()}
//       </div>
//     );
//   }
// }

export default Card;
